import React, { Component } from "react";
import TicktingTable from "./TicktingCommon/TicktingTable";
import { connect } from "react-redux";
import { TickList, CheckLoader } from "../Redux/action/tickList";
import { dataUser, dataLocation } from "./Helpers/util";
import { Navigate } from "react-router-dom";
import MarketingPanel from "../Component/MarketingPanel";
import { getServiceAccess } from "../Redux/action/userActions";
import axios from "axios";
import moment from "moment";
import mixpanel from "mixpanel-browser";
import RaiseTicket from "./CommonComponent/RaiseTicket";
import TicketFilterExport from "./CommonComponent/TicketFilterExport";
import Sidebar from "../Component/Layout/Sidebar";
import CustomHeader from "../Component/Layout/Header";
import { Layout } from "antd";
import SwSelect from "./Common/SwReactSelect/SwReactSelect";
import AntDDatePicker from "./Common/AntDDateTimePicker/AntDDatePicker";
import SwInput from "./Common/FormComponent/SwInput";
import SwButton from "./Common/SwButtons/SwButtons";
import dayjs from "dayjs"
import AntDDropdown from "./Common/AntDDropdown/AntDDropdown";
import SwIconButton from "./Common/SwIconButton/SwIconButton";
import { icons } from "antd/es/image/PreviewGroup";

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation()
var LocationObj = JSON.parse(userDataLocal1);
var exportData = [];

class TicktingManagement extends Component {
  constructor(props) {
    super(props);

    
    this.state = {
      TicktingAllListRows: "",
      // raisedBySelect: false,
      locationFilter: 0,
      status: "All" ,
      status1: 'spoc',
      startDate: moment().subtract(3, "months").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      company_id: UserObj ? UserObj?.company_id : null,
      location: null,
      location1: null,
      locationSpoc: [],
      ticketStatus: [],
      ticketRaisedBy: [],
      collapsed: true,
      pgno: 1,
      row: 25,
      dropdown: false,
      sort: "",
      FilterData: [],
      isSearchVisible: false,
      searchText: "",
      accessServiceLists: [],
      loaderServiceAccess: true,
      userRole: [], 
      // userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      loadingExport: (
        <li style={{ color: "#666666d4", cursor: "default" }}>
          <img src="img/submen3.svg" /> Loading Export Ticket Booking
        </li>
      ),
    };



    this.forwordPage = this.forwordPage.bind(this);
    this.pageBackword = this.pageBackword.bind(this);
    this.handelDropdown = this.handelDropdown.bind(this);
  }
  toggleCollapsed = () => {
    this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
  };

  foterSet = (langValue) => {

    this.setState({
      FilterData: langValue,
    });
  };

  handleLocation = (loca) => {
    this.setState({
      FilterData: loca,
    });
  };

  handelDropdown() {
    this.setState({
      dropdown: !this.state.dropdown,
    });
  }

  toggleSearchHandler = () => {
    const isVisible = this.state.isSearchVisible;
    this.setState({
      isSearchVisible: !isVisible,
    });
  };

  StatusMethod = (selectedOption) => {
    this.setState({ status: selectedOption.value });
  };

  StatusMethod1 = (selectedOption) => {
  

    this.setState({ status1: selectedOption.value });
  };
  setSelectsort = (e) => {
    this.setState({
      sort: e.target.value,
    });
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let params = {
      pgno: this.state.pgno + 1,
      company_id: newCompanyId?.organizationId,
      row: this.state.row,
      sort: e.target.value,
       ticketType: 'support'
    };
    this.props.CheckLoader();
    this.props.TickList(params);
  };

  selectRows = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    let location = (this.state.location1 === 'all')
    ? this.state.locationSpoc?.map((items) => items.centercode) // Send all locations if 'all' is selected
    : this.state.location1 !== null 
      ? this.state.location1 // Send specific location if selected
      : this.state.locationSpoc?.map((items) => items.centercode); 
    let raisedByValue1 = this.state.status === 'All' ? '':this.state.status
    let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let param = {
      pgno: this.state.pgno + 1,
      status: raisedByValue1,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      location: location,
   
      company_id: newCompanyId?.organizationId,
       ticketType: 'support',
      row: e.target.value,
      // location:
      //   this.state.FilterData.locationFilter == [""]
      //     ? LocationObj
      //     : this.state.FilterData.locationFilter,
    };
    this.props.TickList(param);
    this.props.CheckLoader();
  };

  setPage = (e) => {
    this.setState({
      pgno: 1,
    });
  };

  handelChangeValLang = (e) => {
   
    // if (e.target.value === 'GGN6') {
    //   this.setState({ raisedBySelect: true })
    // }
    this.setState({
      location1: e.target.value
    });

  };

  forwordPage(e) {
    this.setState({
      pgno: this.state.pgno + 1,
    });

    let location = (this.state.location1 === 'all')
      ? this.state.locationSpoc?.map((items) => items.centercode) // Send all locations if 'all' is selected
      : this.state.location1 !== null 
        ? this.state.location1 // Send specific location if selected
        : this.state.locationSpoc?.map((items) => items.centercode); 
    let raisedByValue1 = this.state.status === 'All' ? '':this.state.status
    let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let param = {
      pgno: this.state.pgno + 1,
      company_id: newCompanyId?.organizationId,
      row: this.state.row,
      status: raisedByValue1,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      location: location,
      search: this.state.searchText,
       ticketType: 'support'
    };
    this.props.TickList(param);
    this.props.CheckLoader();
  }

  pageBackword(e) {
    this.setState({
      pgno: this.state.pgno - 1,
    });

    let location = (this.state.location1 === 'all')
    ? this.state.locationSpoc?.map((items) => items.centercode) // Send all locations if 'all' is selected
    : this.state.location1 !== null 
      ? this.state.location1 // Send specific location if selected
      : this.state.locationSpoc?.map((items) => items.centercode); 
    let raisedByValue1 = this.state.status === 'All' ? '':this.state.status
    let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let param = {
      status: raisedByValue1,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      location: location,
      pgno: this.state.pgno - 1,
      company_id: newCompanyId?.organizationId,
      row: this.state.row,
      // sort: this.state.sort,
      search: this.state.searchText,
       ticketType: 'support'
    };
    this.props.TickList(param);
    this.props.CheckLoader();
  }

  changeFilterData = (event) => {
    let location = (this.state.location1 === 'all')
    ? this.state.locationSpoc?.map((items) => items.centercode) // Send all locations if 'all' is selected
    : this.state.location1 !== null 
      ? this.state.location1 // Send specific location if selected
      : this.state.locationSpoc?.map((items) => items.centercode); 
    const searchText = event.target.value;
    let newCompanyId = JSON.parse(localStorage.getItem('headData')); // Extract the value from the event
    this.setState({ searchText }, () => {
      let params = {
        company_id: newCompanyId?.organizationId,
        pgno: this.state.pgno,
        row: this.state.row,
        search: this.state.searchText, // Use the extracted searchText
        startDate: this.state.startDate,
        location: location,
        endDate: this.state.endDate,
         ticketType: 'support'
      };
      this.props.TickList(params);
    });
  };

  clearSearchBox = () => {
    this.setState({ searchText: "" });
  };




  submitFilter = (e) => {
    e.preventDefault();
  
    // Check if 'all' is selected, then send all location centercodes
    let location = (this.state.location1 === 'all')
      ? this.state.locationSpoc?.map((items) => items.centercode) // Send all locations if 'all' is selected
      : this.state.location1 !== null 
        ? this.state.location1 // Send specific location if selected
        : this.state.locationSpoc?.map((items) => items.centercode); // Send all locations if nothing selected and locations exist
  
    let raisedByValue = this.state.status1;
    let raisedByValue1 = this.state.status === 'All' ? '' : this.state.status;
    let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let parm = {
      company_id: newCompanyId?.organizationId,
      status: raisedByValue1,
      pgno: this.state.pgno,
      row: this.state.row,
      location: location, // Conditionally set location
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      raisedBy: raisedByValue,
      ticketType: 'support' // Conditionally set raisedBy value
    };
  
    if (this.state.status1 === 'me') {
      parm.userId = String(UserObj.rec_id);
    }
  
    this.props.CheckLoader();
    this.props.TickList(parm);
  };

 

  componentWillMount() {
    this.fetchServiceAccess();
  }

  fetchServiceAccess = async () => {
    const getCompanyId = this.state.company_id;
 
    const response = await getServiceAccess(getCompanyId);
    this.setState({ accessServiceLists: response, loaderServiceAccess: false });
  };

  supportTicketView() {
    mixpanel.track("Reports Support tickets page view", {
      PageName: "Support tickets page",
      UserEmail: UserObj.email,
      UserName: UserObj.fname + " " + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: this.state.company_id,
      CompanyName: UserObj.company_name,
      Type: "Support tickets page",
    });
  }

  exportView() {
    mixpanel.track("Reports Support tickets Export", {
      PageName: "Support tickets page",
      UserEmail: UserObj.email,
      UserName: UserObj.fname + " " + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: this.state.company_id,
      CompanyName: UserObj.company_name,
      Type: "Support tickets page",
    });
  }

  // locationData1 = () => {
  //   let authToken = JSON.parse(localStorage.getItem('headData'))

  //   const params = {
  //     params: { spoc: UserObj.rec_id, client: UserObj.company_id }, headers: {
  //       Authorization: authToken?.spintlyToken,
  //     }
  //   };
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
  //       params
  //     )
  //     .then((res) => {
  //       if (res.data.status == "success") {
  //         this.setState({
  //           locationSpoc: res.data.data,
  //         });
  //       }
  //     });
  // }

  setuserlist = async () => {
    try {
      if (!this.state.locationSpoc || this.state.locationSpoc.length === 0) {
        console.warn("Skipping setuserlist: locationSpoc is empty.");
        return;
      }
  
      let raisedByValue1 = this.state.status === 'All' ? '' : this.state.status;
      let raisedByValue = this.state.status1;
      let newCompanyId = JSON.parse(localStorage.getItem('headData'));
      let params = {
        company_id: newCompanyId?.organizationId,
        pgno: this.state.pgno,
        row: this.state.row,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        location: this.state.locationSpoc.map((items) => items.centercode),
        status: raisedByValue1,
        raisedBy: raisedByValue,
        ticketType: 'support',
      };
  
      if (this.state.status1 === 'me') params.userId = String(UserObj.rec_id);
  
      await this.props.TickList(params);
    } catch (error) {
      console.error('Error in setting user list:', error);
    }
  };
  
  async componentDidMount() {
      const userDataLocal = dataUser(); // Fetch user data
    
        if (userDataLocal) {
          try {
            const UserObj = JSON.parse(userDataLocal);
            this.setState({
              userRole: UserObj.role_data || [], // Ensure it is always an array
            });
          } catch (error) {
            console.error("Error parsing user data:", error);
          }
        }
    await this.locationData1();
  
    if (this.state.locationSpoc && this.state.locationSpoc.length > 0) {
      await this.setuserlist();
    } else {
      console.warn("Skipping setuserlist in componentDidMount: locationSpoc is empty.");
    }
  
    this.supportTicketView();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.state.locationSpoc !== prevState.locationSpoc) {
      if (this.state.locationSpoc && this.state.locationSpoc.length > 0) {
        this.setuserlist();
      } else {
        console.warn("Skipping setuserlist in componentDidUpdate: locationSpoc is empty.");
      }
    }
  }
  
  locationData1 = async () => {
    try {
      let authToken = JSON.parse(localStorage.getItem('headData'));
  
      const axiosConfig = {
        params: {
          spoc: UserObj.rec_id,
          client: this.state.company_id
        },
        headers: {
          Authorization: authToken?.spintlyToken,
        }
      };
  
      const response = await axios.get(`${process.env.REACT_APP_API_URL}basic-data/get-centers-by-spoc`, axiosConfig);
  
      if (response.data.status === "success") {
        this.setState({
          locationSpoc: response.data.data || [] // Ensure an empty array if data is missing
        });
      }
    } catch (error) {
      console.error("Error in locationData1:", error);
    }
  };

  // componentDidUpdate(prevProps, prevState) {

  //   if (this.props.TicktingAllListRows !== prevProps.TicktingAllListRows || this.state.TicktingAllListRows !== prevState.TicktingAllListRows) {

  //     this.getTotalCount();
  //   }
  // }

  // async getTotalCount() {
  //   let authToken = JSON.parse(localStorage.getItem('headData'))
  //   let params = {
  //     pgno: 1,
  //     row: this.state.TicktingAllListRows,
  //     company_id: this.state.company_id,
  //     location: (this.state.locationFilter > 0) ? this.state.locationFilter : this.state.location,
  //     startDate: this.state.startDate,
  //     endDate: this.state.endDate,
  //   };
  
  //   const total = await axios
  //     .post(`${process.env.REACT_APP_API_URL}user/ticketListV2`, params, {
  //       headers: {
  //         Authorization: authToken?.spintlyToken,
  //       }
  //     })
  //     .then((response) => {
  //       return response?.data?.data?.list;
  //     });
  //   this.getAllExportData(total);
  // }


  // getAllExportData(list) {

  // const headers = [
  //   { label: "Request No.", key: "requestID" },
  //   { label: "Subcategory", key: "subCategory" },
  //   { label: "Subject", key: "Subject" },
  //   { label: "Description", key: "Description" },
  //   { label: "Location", key: "floorName" },
  //   // { label: "Company Name", key: "companyName" },
  //   { label: "Assignee", key: "assignee" },
  //   // { label: "Issue", key: "issue" },
  //   { label: "Ticket Created", key: "createdDate" },
  //   // { label: "Priority", key: "priority" },
  //   // { label: "Channel", key: "channel" },
  //   // { label: "Sub Category", key: "subCategory" },
  //   // { label: "Due Date", key: "dueDate" },
  //   { label: "Ticket Closed", key: "closedDate" },
  //   { label: "Raised By", key: "createdBy" },
  //   { label: "Ticket Status", key: "status" },
  // ];

  //   const arr2 = filteredData.map((v) => ({
  //     requestID: v.requestId,
  //     subCategory: v.subCategory,
  //     Subject: v.Subject,
  //     Description: v.Description,
  //     floorName: v.floorName,
  //     companyName: v.domain,
  //     createdBy: v.contactName,
  //     assignee: v.ticketOwnerName,
  //     issue: v.Subject,
  //     createdDate: v.createdTime,
  //     priority: v.Priority,
  //     channel: v.Channel,
  //     subCategory: v.subCategory,
  //     status: v.Status,
  //     dueDate: v.dueDate,
  //     closedDate: v.ticketCloseTime,
  //   }));

  //   this.setState({
  //     loadingExport: (
  //       <li>
  //         <CSVLink
  //           data={arr2}
  //           headers={headers}
  //           filename={"Ticket Booking.csv"}
  //           className="innertext"
  //           onClick={this.exportView}
  //         >
  //           <img src="img/submen3.svg" /> Export Ticket Booking
  //         </CSVLink>
  //       </li>
  //     ),
  //   });
  // }




  componentWillReceiveProps(props) {
    if (
      props.ticketReducer &&
      this.props.ticketReducer.TicketAllList.status == 200
    ) {
      this.setState({
        TicktingAllListRows:
          props.ticketReducer &&
          this.props.ticketReducer.TicketAllList &&
          this.props.ticketReducer.TicketAllList.data &&
          this.props.ticketReducer.TicketAllList?.data?.rows,
      });
    }
  }





  refreshPage = (e) => {
        this.setState({
      pgno: 1,
      row: 25,
    });
    let location = (this.state.location1 === 'all')
    ? this.state.locationSpoc?.map((items) => items.centercode) // Send all locations if 'all' is selected
    : this.state.location1 !== null 
      ? this.state.location1 // Send specific location if selected
      : this.state.locationSpoc?.map((items) => items.centercode); 
      let newCompanyId = JSON.parse(localStorage.getItem('headData'));
    let param = {
      company_id: newCompanyId?.organizationId,
      row: 25,
      pgno: 1,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      location: location,
       ticketType: 'support'
    };
    this.props.TickList(param);
  };
  setParams = () => {
    let raisedByValue1 = this.state.status === 'All' ? '' : this.state.status;
    
    let params = {
      company_id: this.state.company_id,
      pgno: this.state.pgno,
      row: this.state.row,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      location: this.state.locationSpoc?.map((items) => items.centercode),
      status: raisedByValue1,
    };
   

    return params;
  };





  render() {



    const params = this.setParams();

    var ticketStatus = [

      {
        value: "All",
        label: "All",
      },
      {
        value: "Closed",
        label: "Closed",
      },
      // {
      //   value: "In Progress",
      //   label: "In Progress",
      // },
      {
        value: "Open",
        label: "Open",
      },
    
    ];
    var ticketRaisedBy = [
      {
        value: "all",
        label: "All",
      },
      {
        value: "spoc",
        label: "SPOCs",
      },
      {
        value: "me",
        label: "Me",
      },
      {
        value: "nospoc",
        label: "Employees",
      },
    ];

  
  
      const { userRole } = this.state;
  
      // Ensure userRole is available before checking SupportTickets
      const SupportTickets = userRole.find(
        (element) =>
          element.service_id == "17" &&
          (element.role_for_read == "1" || element.role_for_write == "1")
      );
  

  
      // Redirect only if userRole has loaded and SupportTickets is missing
      if (userRole.length > 0 && !SupportTickets) {
        return <Navigate to="/Dashboard" />;
      }
    const ticketReducer = this.props.ticketReducer.TicketAllList;
    const Loader = this.props.ticketReducer.loader;

    let serviceAccess = true;
    const serviceAccessId = 17;
    if (this.state.accessServiceLists.length > 0) {
      let serviceAccessobject = {};
      this.state.accessServiceLists.map((e) => {
        if (e.id == serviceAccessId) serviceAccessobject = e;
      });
      serviceAccess = false;
      if (serviceAccessobject)
        serviceAccess = serviceAccessobject.service_access;
    }
    const locationOptions = [
      { value: "all", label: "All" },
      ...(this.state.locationSpoc
        ? this.state.locationSpoc.map((item) => ({
            value: item.centercode,
            label: item.location_name_zoho,
          }))
        : []),
    ];

    const barMenu = {
      items: [
        {
          key: "export",
          icon: <i className="bi bi-upload" />,
          label: "Export Ticket Booking",
          onClick: () => this.setState({ showExportCanvas: true }),
        },
        {
          key: "refresh",
          icon: <i className="bi bi-arrow-clockwise" />,
          label: "Refresh List",
          onClick: () => this.refreshPage(),
        },
      ],
    };

      
    return (
      <>
       <Layout>
      
      <Sidebar collapsed={this.state.collapsed} />

      <CustomHeader collapsed={this.state.collapsed} toggleCollapsed={this.toggleCollapsed} />
      

      <Layout className={this.state.collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
        <RaiseTicket  
        show={this.state.showRaiseTicket}
        onClose={() => this.setState({ showRaiseTicket: false })}
        ticketListApi={this.setuserlist}
        />
      
        <TicketFilterExport 
        show={this.state.showExportCanvas}
        onClose={() => this.setState({ showExportCanvas: false })}
        />
        {serviceAccess === true ? (
          <>
            <div className="PageContent">
              <div className="row">
                
                <div className="col-md-6 col-xl-6 col-lg-6 ">
                  <div className='SwHeading'>
                    <h2>Ticketing</h2>
                  </div>
                </div>
                
                <div className="col-md-12 col-lg-6">
                  <div className="PageHead_Optons_Row">
                    <ul className="PageHead_Optons_RightAligned">
                      <li>
                        <div className="SwInputWithIcon">
                          <SwInput
                          placeholder="Search..."
                          value={this.state.searchText}
                          onChange={this.changeFilterData}
                          />
                          <span className="SwInputicon">
                          <i className="bi bi-search"></i>
                          </span>
                        </div>
                      </li>
                      <li className="ToHideMobile">
                        <AntDDropdown
                          menu={barMenu}
                          trigger={["click"]}
                          placement="bottomRight"
                        >
                          <SwIconButton size="sm">
                            <i className="bi bi-list" />
                          </SwIconButton>
                        </AntDDropdown>
                      </li>
                      <li>
                        <SwButton
                          type="button"
                          size = "sm"
                          onClick={() => this.setState({ showRaiseTicket: true })}
                        >
                          Raise a ticket
                        </SwButton>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-3">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Location</label>
                    <SwSelect
                        options={locationOptions}
                        value={locationOptions.find(
                      (opt) => opt.value === this.state.location1
                        )}
                        onChange={(selectedOption) => {
                        this.setState({ location1: selectedOption?.value || "all" });
                      this.handelChangeValLang({
                        target: { value: selectedOption?.value || "all" },
                        });
                        }}
                        isClearable={false}
                        placeholder="Select Location"
                        defaultValue={{ value: "All", label: "All" }}
                    />
                  </div>
                </div>

                <div className="col-lg-3">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Start Date</label>
                      <AntDDatePicker
                      id='ticketsfilterstartdate'
                        value={
                          this.state.startDate
                            ? dayjs(this.state.startDate, "YYYY-MM-DD")
                            : null
                        }
                        format="YYYY-MM-DD"
                        onChange={(date, dateString) =>
                          this.setState({ startDate: dateString })
                        }
                        placeholder='Select start date'
                      />
                    </div>
                </div>
                <div className="col-lg-3">
                  <label className="SwFormLabel">End Date</label>
                  <AntDDatePicker
                    id='ticketsfilterenddate'
                    format="YYYY-MM-DD"
                    value={
                      this.state.endDate
                        ? dayjs(this.state.endDate, "YYYY-MM-DD")
                        : null
                    }
                    onChange={(date, dateString) =>
                      this.setState({ endDate: dateString })
                    }
                  />
                </div>

                <div className="col-lg-3">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Status</label>
                    <SwSelect
                      name="status"
                      onChange={this.StatusMethod}
                      options={ticketStatus}
                      value={ticketStatus.find(option => option.value === this.state.status)}
                      defaultValue={{ value: "All", label: "All" }}
                      isClearable={false}
                    />
                  </div>
                </div>
                
              </div>



              <div className="row">

                <div className="col-lg-3">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Ticket raised by</label>
                    <SwSelect
                      name="status1"
                      onChange={this.StatusMethod1}
                      options={ticketRaisedBy}
                      value={ticketRaisedBy.find(option => option.value === this.state.status1)} // Set the selected value
                      defaultValue={{ value: "spoc", label: "SPOCs" }}
                      isClearable={false}
                    />
                  </div>
                </div>
                  
                <div className="col-lg-3">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel invisible">No Label</label>
                    <SwButton 
                    type="submit"
                    size = "sm"
                    variant = "dark"
                    onClick={this.submitFilter}
                    >
                      Apply Filter
                    </SwButton>
                  </div>
                </div>

              </div>

              <div className="row">
                <div className="col-12">
                  <div className="mainAllTable">
                    <div
                      className={Loader == true ? "loader disable" : "loader"}
                    >
                      <img
                        className=""
                        src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                        alt="Loder"
                      />
                    </div>
                    <TicktingTable
                      params={params}
                      ticketListApi1={this.setuserlist}
                      pgno={this.state.pgno}
                      row={this.state.row}
                      onPageChange={(page, pageSize) => {
                        this.setState(
                          { pgno: page, row: pageSize },
                          () => this.setuserlist() // ✅ API call here
                        );
                      }}
                    />

                  </div>
                </div>
              </div>
            </div>
          </>
        ) : this.state.loaderServiceAccess == true ? (
          <>
            <div className="loader">
              <img
                className=""
                src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                alt="Loder"
              />
            </div>
          </>
        ) : (
          <MarketingPanel />
        )}
          </Layout>
        
                </Layout>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  ticketReducer: state.ticketReducer,
});

const mapActionsToProps = {
  TickList,
  CheckLoader,
};

export default connect(mapStateToProps, mapActionsToProps)(TicktingManagement);
